// src/app/services/adpGage.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IDisconnect, IDisconnectParams, UpdatePayload } from '../models';

export const disconnectApi = createApi({
  reducerPath: 'disconnectApi',
  baseQuery,
  endpoints: (builder) => ({
    getDisconnectParams: builder.query<{ disconnect: IDisconnectParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/disconnects/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getDisconnect: builder.query<IDisconnect, number>({
      query: (id) => `/api/v1.0/ahu/disconnects/${id}`,
      transformResponse: (data: IDisconnect) => {
        data.params = data.disconnect_params ? JSON.parse(data.disconnect_params) : {};
        return data;
      },
    }),
    getAllDisconnectsCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/disconnects/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getDisconnectsCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/disconnects/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateDisconnect: builder.mutation<IDisconnect, UpdatePayload<IDisconnect>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/disconnects/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: IDisconnect) => {
        data.params = data.disconnect_params ? JSON.parse(data.disconnect_params) : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetDisconnectQuery,
  useGetDisconnectParamsQuery,
  useGetAllDisconnectsCountQuery,
  useLazyGetDisconnectsCountQuery,
  useGetDisconnectQuery,
  useUpdateDisconnectMutation,
} = disconnectApi;
